import PackageFocusElements from "ee/navigation/FocusElements/PackageIDE";

export default PackageFocusElements;
